<template>
    <div class="row offset-banner-margin" v-if="!status">
        <div class="col-12">
            <div class="banner">
                <div class="row">
                    <div class="col-12 align-self-center">
                        <div class="font-weight-bold">Complete your profile!</div>
                        <div>Answer few quick question regarding your remote readiness.</div>
                        <div class="text-right">
                            <a href="/setup/remote-readiness" class="text-white font-weight-bold">Let's do it!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // status: true
            }
        },

        computed: {
            currentUser () {
                return this.$store.state.currentUser; 
            }, 

            timezone () {
                return this.$store.state.timezone; 
            }, 

            status () {
                return this.currentUser.remote_readiness_status; 
            }, 
        }, 

        methods: {
            async getStatus() {
                // const url = '/me';
                // const data = await axios.get(url);

                // this.status = data.data.data.remote_readiness_status;
            }
        },

        mounted() {
            // this.getStatus();
        }
    }
</script>

<style scoped>
    .banner {
        width: 100%;
        background: url("/images/Banner_Background.png");
        background-position-x: center;
        background-size: cover;
        position: relative;
        top: -32px;
        border-radius: 3px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
        padding: 24px 16px;
        margin: 0 auto;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        letter-spacing: 0.5px;
        line-height: 22px;
    }

    .banner img {
        position: absolute;
        left: 0;
        bottom: -24px;
    }
</style>
